

export const helpdata: { icon: string; title: string; text: string }[] = [
  {
    icon: "/images/help/donation.svg",
    title: "Give donation",
    text: "Your donation funds vital programs and supports communities in need. Every contribution counts!",
  },
  {
    icon: "/images/help/volunteer.svg",
    title: "Become volunteer",
    text: "Join us in making a difference! Volunteer and work directly with our community projects. Every contribution counts!",
  },
  {
    icon: "/images/help/food-supply.svg",
    title: "Provide food supply",
    text: "Donate food supplies to help us combat hunger and support families in need. Every contribution counts!",
  },
];

export const CauseData: {
  image: string;
  title: string;
  slug: string;
  text: string;
  raised: string;
  goal: string;
}[] = [
  {
    image: "/images/causes/cause-1.jpg",
    title: "Give medical related help for african children",
    slug: "cause-1",
    text: "You can relay on our amazing features list and also our customer services will be great experience.",
    raised: "₹65,360",
    goal: "₹124,500",
  },
  {
    image: "/images/causes/cause-2.jpg",
    title: "Give small bunch of colors to little kids, joy of colors",
    slug: "cause-2",
    text: "You can relay on our amazing features list and also our customer services will be great experience.",
    raised: "₹65,360",
    goal: "₹124,500",
  },
  {
    image: "/images/causes/cause-3.jpg",
    title: "Send poor children to school to become superhero",
    slug: "cause-3",
    text: "You can relay on our amazing features list and also our customer services will be great experience.",
    raised: "₹65,360",
    goal: "₹124,500",
  },
  {
    image: "/images/causes/cause-4.jpg",
    title: "Uniting Hearts and Minds through Healthcare Outreach",
    slug: "cause-4",
    text: "You can relay on our amazing features list and also our customer services will be great experience.",
    raised: "₹65,360",
    goal: "₹124,500",
  },
  {
    image: "/images/causes/cause-5.jpg",
    title: "Auctioning Masterpieces to Support Arts Education in Schools",
    slug: "cause-5",
    text: "You can relay on our amazing features list and also our customer services will be great experience.",
    raised: "₹65,360",
    goal: "₹124,500",
  },
  {
    image: "/images/causes/cause-6.jpg",
    title: "Medical Mission Providing Care in Underserved Communities",
    slug: "cause-6",
    text: "You can relay on our amazing features list and also our customer services will be great experience.",
    raised: "₹65,360",
    goal: "₹124,500",
  },
  {
    image: "/images/causes/cause-7.jpg",
    title: "Empowering Women and Girls Through Education Initiatives",
    slug: "cause-7",
    text: "You can relay on our amazing features list and also our customer services will be great experience.",
    raised: "₹65,360",
    goal: "₹124,500",
  },
  {
    image: "/images/causes/cause-8.jpg",
    title: "Harnessing Renewable Energy for Environmental Conservation",
    slug: "cause-8",
    text: "You can relay on our amazing features list and also our customer services will be great experience.",
    raised: "₹65,360",
    goal: "₹124,500",
  },
  {
    image: "/images/causes/cause-9.jpg",
    title: "A Fundraising Gala for Education Equality and Access",
    slug: "cause-9",
    text: "You can relay on our amazing features list and also our customer services will be great experience.",
    raised: "₹65,360",
    goal: "₹124,500",
  },
];

export const Eventdata: {
  image: string;
  title: string;
  text: string;
  date: string;
  location: string;
  type: string;
  entrants: string;
  duration: string;
  category: string;
  detail: string;
  slug: string;
}[] = [
  {
    image: "/images/event/event-1.jpg",
    title: "You should have eagle’s eye on new trends and techonogies",
    slug: "event-1",
    text: "Business Park, Opp. Corns Sam Restaurant, New Yoark, US",
    date: "May 10, 2024",
    location: "San Marcos",
    type: "Open",
    entrants: "Unlimited",
    duration: "1655 Days",
    category: "Calendar, Dontaions",
    detail:
      "Donec hendrerit, dui quis ultricies eleifend, ipsum sapien auctor ligula, vitae interdum augue metus nec sem. Pellentesque mollis ex risus, eget dignissim nibh fermentum in. Cras eu ipsum eget ante ullamcorper vehicula. Suspendisse non blandit mi.Mauris eu sapien urna. Fusce eu luctus augue, non vestibulum felis. Fusce sollicitudin porta augue non porta. Vivamus ullamcorper tristique nisi, in mattis elit porta vitae. Curabitur euismod lectus non maximus dictum. Vivamus luctus, eros at posuere",
  },
  {
    image: "/images/event/event-2.jpg",
    title: "New Seminar on Newest Food Recipe from World’s Best",
    slug: "event-2",
    text: "Business Park, Opp. Corns Sam Restaurant, New Yoark, US",
    date: "May 10, 2024",
    location: "San Marcos",
    type: "Open",
    entrants: "Unlimited",
    duration: "1655 Days",
    category: "Calendar, Dontaions",
    detail:
      "Donec hendrerit, dui quis ultricies eleifend, ipsum sapien auctor ligula, vitae interdum augue metus nec sem. Pellentesque mollis ex risus, eget dignissim nibh fermentum in. Cras eu ipsum eget ante ullamcorper vehicula. Suspendisse non blandit mi.Mauris eu sapien urna. Fusce eu luctus augue, non vestibulum felis. Fusce sollicitudin porta augue non porta. Vivamus ullamcorper tristique nisi, in mattis elit porta vitae. Curabitur euismod lectus non maximus dictum. Vivamus luctus, eros at posuere",
  },
  {
    image: "/images/event/event-3.jpg",
    title: "Learn from small things to create something bigger.",
    slug: "event-3",
    text: "Business Park, Opp. Corns Sam Restaurant, New Yoark, US",
    date: "May 10, 2024",
    location: "San Marcos",
    type: "Open",
    entrants: "Unlimited",
    duration: "1655 Days",
    category: "Calendar, Dontaions",
    detail:
      "Donec hendrerit, dui quis ultricies eleifend, ipsum sapien auctor ligula, vitae interdum augue metus nec sem. Pellentesque mollis ex risus, eget dignissim nibh fermentum in. Cras eu ipsum eget ante ullamcorper vehicula. Suspendisse non blandit mi.Mauris eu sapien urna. Fusce eu luctus augue, non vestibulum felis. Fusce sollicitudin porta augue non porta. Vivamus ullamcorper tristique nisi, in mattis elit porta vitae. Curabitur euismod lectus non maximus dictum. Vivamus luctus, eros at posuere",
  },
  {
    image: "/images/event/event-4.jpg",
    title: "Literary Escapade Book Reading and Discussion.",
    slug: "event-4",
    text: "Business Park, Opp. Corns Sam Restaurant, New Yoark, US",
    date: "Nov 10, 2025",
    location: "San Marcos",
    type: "Open",
    entrants: "Unlimited",
    duration: "1655 Days",
    category: "Calendar, Dontaions",
    detail:
      "Donec hendrerit, dui quis ultricies eleifend, ipsum sapien auctor ligula, vitae interdum augue metus nec sem. Pellentesque mollis ex risus, eget dignissim nibh fermentum in. Cras eu ipsum eget ante ullamcorper vehicula. Suspendisse non blandit mi.Mauris eu sapien urna. Fusce eu luctus augue, non vestibulum felis. Fusce sollicitudin porta augue non porta. Vivamus ullamcorper tristique nisi, in mattis elit porta vitae. Curabitur euismod lectus non maximus dictum. Vivamus luctus, eros at posuere",
  },
  {
    image: "/images/event/event-5.jpg",
    title: "A Journey Through Time Historical Reenactment Fair.",
    slug: "event-5",
    text: "Business Park, Opp. Corns Sam Restaurant, New Yoark, US",
    date: "May 10, 2024",
    location: "San Marcos",
    type: "Open",
    entrants: "Unlimited",
    duration: "1655 Days",
    category: "Calendar, Dontaions",
    detail:
      "Donec hendrerit, dui quis ultricies eleifend, ipsum sapien auctor ligula, vitae interdum augue metus nec sem. Pellentesque mollis ex risus, eget dignissim nibh fermentum in. Cras eu ipsum eget ante ullamcorper vehicula. Suspendisse non blandit mi.Mauris eu sapien urna. Fusce eu luctus augue, non vestibulum felis. Fusce sollicitudin porta augue non porta. Vivamus ullamcorper tristique nisi, in mattis elit porta vitae. Curabitur euismod lectus non maximus dictum. Vivamus luctus, eros at posuere",
  },
  {
    image: "/images/event/event-6.jpg",
    title: "Leadership Summit Empowering Tomorrow's Leaders.",
    slug: "event-6",
    text: "Business Park, Opp. Corns Sam Restaurant, New Yoark, US",
    date: "Dec 10, 2025",
    location: "San Marcos",
    type: "Open",
    entrants: "Unlimited",
    duration: "1655 Days",
    category: "Calendar, Dontaions",
    detail:
      "Donec hendrerit, dui quis ultricies eleifend, ipsum sapien auctor ligula, vitae interdum augue metus nec sem. Pellentesque mollis ex risus, eget dignissim nibh fermentum in. Cras eu ipsum eget ante ullamcorper vehicula. Suspendisse non blandit mi.Mauris eu sapien urna. Fusce eu luctus augue, non vestibulum felis. Fusce sollicitudin porta augue non porta. Vivamus ullamcorper tristique nisi, in mattis elit porta vitae. Curabitur euismod lectus non maximus dictum. Vivamus luctus, eros at posuere",
  },
];

export const footerLinks: { link: string, url:string }[] = [
  {
    link: "Education for All",
    url: "/education"
  },
  {
    link: "Health & Wellness",
    url: "/health"
  },
  {
    link: "Community Awareness",
    url: "/community-development"
  },

  {
    link: "News",
    url: "/news"
  },
  {
    link: "Events",
    url: "/events"
  },
  {
    link: "Gallery",
    url: "/gallery"
  },
];

export const Reviews: {
  clientImg: string;
  clientName: string;
  review: string;
  post: string;
}[] = [
  {
    clientImg: "/images/testimonial/client-1.jpg",
    clientName: "Michelle Anderson",
    review:
      "You can relay on our amazing features list and also our customer services will be great experience. You can relay on our amazing features.",
    post: "CEO, Buddh Bhumi Kushinara Charitable Trust",
  },
  {
    clientImg: "/images/testimonial/client-2.jpg",
    clientName: "Michelle Anderson",
    review:
      "You can relay on our amazing features list and also our customer services will be great experience. You can relay on our amazing features.",
    post: "Managing Director, Buddh Bhumi Kushinara Charitable Trust",
  },
];


export const PressReleaseData: {
    title: string,
    subtitle? : string,
    date: string,
    summary:string,
    author: string,
    image: string
    thumbnail:string
    category: string,
    slug: string,
  }[] = [
  {
    title: "Successful Health Camp Conducted in Kusinara",
    subtitle : "Press First",
    date: "2025-09-25",
    summary:
      "Over 500 people benefited from free medical checkups and medicines Over 500 people benefited from free medical checkups and medicines Over 500 people benefited from free medical checkups and medicines...",
    author: "Dr. Sharma",
    image:
      "https://topicfinderwordpress-bc85.kxcdn.com/wp-content/uploads/2023/08/Press-Release-Distribution-Sites.jpg",
    thumbnail:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpD83xc7HfXgj4OGpO0riLvlaK6tmN8Z9heQ&s",
    category: "Events",
    slug: "press-release-1",
  },
  {
    title: "NGO Launches New Education Initiative",
    subtitle : "Press Second",
    date: "2025-10-01",
    summary:
      "We are proud to announce a new education program for underprivileged children...",
    author: "Admin",
    image:
      "https://topicfinderwordpress-bc85.kxcdn.com/wp-content/uploads/2023/08/Press-Release-Distribution-Sites.jpg",
    thumbnail:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpD83xc7HfXgj4OGpO0riLvlaK6tmN8Z9heQ&s",
    category: "Announcement",
   slug:"press-release-2",
  },
  {
    title: "Media Coverage: Buddha Bhumi Kusinara Charitable Trust",
    subtitle : "Press Third",
    date: "2025-09-15",
    summary:
      "The local media highlighted our ongoing awareness programs in the region...",
    author: "Media Team",
    image:
      "https://topicfinderwordpress-bc85.kxcdn.com/wp-content/uploads/2023/08/Press-Release-Distribution-Sites.jpg",
    thumbnail:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpD83xc7HfXgj4OGpO0riLvlaK6tmN8Z9heQ&s",
    category: "Media Coverage",
    slug: "press-release-3",
  },
];